/* List of Redux constants */
export const VACANCY_ACCESS_SET_FORM_LOADING = '@vacancy-access/set-form-loading';
export const VACANCY_ACCESS_SET_FORM_UPDATING = '@vacancy-access/set-form-updating';
export const VACANCY_ACCESS_SET_SCHOOL_USERS_SUMMARIES = '@vacancy-documents/set-school-users-summaries';
export const VACANCY_ACCESS_RESET_STATE = '@vacancy-access/reset-state';

/* List of Sagas constants */
export const VACANCY_ACCESS_GET_SCHOOL_USERS_SUMMARIES = '@vacancy-access/get-school-users-summaries';
export const VACANCY_ACCESS_SET_SCHOOL_USERS_TO_DENY = '@vacancy-access/set-school-users-to-deny';



// WEBPACK FOOTER //
// ./src/actions/vacancies/vacancy-access/types.js